module.exports = __webpack_public_path__ + "static/media/favebiz-deals-none.418fa523.svg";